import { render } from "./Footer.vue?vue&type=template&id=21f8d3b4&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=21f8d3b4&scoped=true&lang=css"

import exportComponent from "/builds/gestcoop/gestcoop-client-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f8d3b4"]])

export default __exports__